module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABroAAAADCAYAAADMft8PAAAAOUlEQVR4nO3ZQREAIADDsIF/T5MGOnaXWOizp+0LAAAAAAAAjLmCAQAAAAAAsMjoAgAAAAAAYE+SD2akA0JBktJCAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/xian.png
// module id = v9H8
// module chunks = 1